/* eslint-disable max-len */
import React, { Fragment, useRef, useState} from 'react';
import 'tw-elements';
import TableBody from './TableBody';
import { useOnClickOutside } from '../../../../../CommonMethods/OutsideClick';
import {  useSelector } from 'react-redux';
import { ConvertToTitleCase } from '../../../../../CommonMethods/ConvertToTitleCase';

const Table = ({pageNumber, handleOnClickSort,addOpen,confirmationState, getBranch, sortValue, setConfirmationState,email, branchName, searchParams}) => {
    const [selectedIndex, setSelectedIndex] = useState(null);
    const selectedRef = useRef();
    const ClassList = useSelector(state => state.ClassesSlice);
    const { List} = ClassList;
    const urlParams = new URLSearchParams(window.location.search);
    const branchUrl = urlParams.get('sort');

    /* `useOnClickOutside` is a custom hook that takes two arguments: a ref and a callback function. It
    is used to detect clicks outside of a specific element (in this case, the `selectedRef` element)
    and trigger the callback function (`setSelectedIndex(null)`) when a click is detected outside of
    that element. In this specific code, it is used to close a dropdown menu when a user clicks
    outside of it. */
    useOnClickOutside(selectedRef, () => {
        setSelectedIndex(null)
    });

    /**
     * The function handles sorting based on a given key and current sort value.
     */
    const handleSort = (key) => {
        if(sortValue === '') handleOnClickSort('sort', `${key}+asc`)
        else {
            if(sortValue.includes(key)) handleOnClickSort('sort', `${key}+${sortValue.includes('+desc') ? 'asc' : 'desc'}`)
            else handleOnClickSort('sort', `${key}+asc`)
        }
    }

    return (
        <div class="-mx-1">
            <div className={`flex overflow-auto ${List?.data?.length < 10 ? 'pb-[62px]' : 'pb-[6px]'} scroll-bar px-1`} id="search-result" >
                <table aria-label="Outside Table" className="w-full" id='admin-table'>
                    <thead>
                        <tr class="cursor-pointer">
                            {(searchParams.get('type')==null || searchParams.get('type')=='ledger')&&<th id='ledger_name' class="w-[40%]" onClick={() => {handleSort('ledger_name')}}>
                                <span class="flex items-center justify-start ">Ledger Name
                                    <img className='pl-1.5' loading="lazy" decoding="async" src={branchUrl !== undefined && branchUrl?.split("+")[0] === "ledger_name" ? branchUrl?.split("+")[1] === "asc" ? "/images/sortAsc.svg" : "/images/sortDesc.svg" : "/images/Vector.svg"} alt="icon"/>
                                </span>
                            </th>}
                            <th id='group_name' className={`${searchParams.get('type')==null || searchParams.get('type')=='ledger'?'w-[35%]':'w-[70%]'}`} onClick={() => {handleSort('group_name')}}>
                                <span class="flex items-center ">Group Name
                                    <button type="button" class="pl-1.5 sortedIcon">
                                        <img loading="lazy" decoding="async" src={branchUrl !== undefined && branchUrl?.split("+")[0] === "group_name" ? branchUrl?.split("+")[1] === "asc" ? "/images/sortAsc.svg" : "/images/sortDesc.svg" : "/images/Vector.svg"} alt="icon"/>
                                    </button>
                                </span>
                            </th>
                            {(searchParams.get('type')==null || searchParams.get('type')=='ledger') ? (
                                <>
                                    <th id='status' class="w-[15%]" onClick={() => { handleSort('status') }}>Status
                                        <button type="button" class="pl-1.5 sortedIcon">
                                            <img loading="lazy" decoding="async" src={branchUrl !== undefined && branchUrl?.split("+")[0] === "status" ? branchUrl?.split("+")[1] === "asc" ? "/images/sortAsc.svg" : "/images/sortDesc.svg" : "/images/Vector.svg"} alt="icon"/>
                                        </button>
                                    </th>
                                    <th class="w-[10%]">
                                        <span class="flex items-center justify-center">Actions</span>
                                    </th>
                                </>
                            ) : (
                                <th class="w-[30%] text-centre">Type</th>
                            )}
                        </tr>
                        <tr aria-colspan="7" class="h-1"></tr>
                    </thead>
                    <tbody>
                        {List?.data.map((item , index = 0) => (
                            <Fragment key={item._id}>
                                <TableBody
                                    branchName={branchName}
                                    tableData={item}
                                    setConfirmationState={setConfirmationState}
                                    indexNum={index}
                                    pageNumber={pageNumber}
                                    selectedIndex={selectedIndex}
                                    setSelectedIndex={setSelectedIndex}
                                    selectedRef={selectedRef}
                                    lastIndex={List.data?.length}
                                    email={email}
                                    getBranch={getBranch}
                                    searchParams={searchParams}
                                />
                            </Fragment>
                        ))}
                    </tbody>
                    {List?.data?.length === 0 && (
                        <tbody>
                            <tr>
                                <td style={{ 'line-height': '100px' }} colspan="4" className="no-records-message" id='no-matching-result'>
                                    {'No matching records found.'}
                                </td>
                            </tr>
                        </tbody>
                    )}
                </table>
            </div>
        </div>
    );
}

export default Table;
